import { render, staticRenderFns } from "./thong-ke-hoa-hong-nhan-vien.vue?vue&type=template&id=78326bbf&"
import script from "./thong-ke-hoa-hong-nhan-vien.vue?vue&type=script&lang=js&"
export * from "./thong-ke-hoa-hong-nhan-vien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../boss_taobao/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDataTable,VDatePicker,VFlex,VLayout,VMenu,VTextField})
